import PageFrame from 'components/PageFrame/PageFrame'
import { useCreatePortfolioMutation } from 'api/api'

import { useNavigate } from 'react-router-dom'
import CreateModal from '../../components/GeneralModal/CreateModal'
import { useState } from 'react'
import './portfolio-view.scss'
import PortfoliosFrame from './PortfoliosFrame'

const PortfoliosView = ({}) => {
  const navigate = useNavigate()
  const [createModalIsOpen, setCreateModalIsOpen] = useState(false)

  const [createPortfolio, { isLoading: createPortfolioLoading }] =
    useCreatePortfolioMutation()

  function handleCreatePortfolioSubmit(name) {
    createPortfolio({ name })
  }

  function handleNewPortfolio() {
    setCreateModalIsOpen(true)
  }

  function handlePortfolioClick(portfolio) {
    navigate(`/portfolios/${portfolio.id}`)
  }

  return (
    <PageFrame route="portfolios" showBanner>
      <div className="flex-1 relative p-4 h-full">
        <div className="h-full pr-2 w-full ">
          <div className="flex rounded-t h-[50px] px-6 items-center bg-deep">
            <h5>Portfolios</h5>
          </div>
          <div className="bg-gray-light h-[calc(100%-50px)] pb-4 rounded-b">
            <PortfoliosFrame
              isLoading={createPortfolioLoading}
              onNewPortfolio={handleNewPortfolio}
              onEditPortfolio={handlePortfolioClick}
            />
          </div>
        </div>
      </div>
      <CreateModal
        isOpen={createModalIsOpen}
        onRequestClose={() => setCreateModalIsOpen(false)}
        title="Create Portfolio"
        label="Enter Portfolio Name"
        onSubmit={handleCreatePortfolioSubmit}
      />
    </PageFrame>
  )
}

export default PortfoliosView
